import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { FETCH_SENSITIVE_SUMMARY_CARD_DATA } from "../../DataTagConstants";
import SensitivityBadge from "../../../../components/shared/Badge/SensitivityBadge";

function DataEstateSensitiveCard() {
  const dispatch = useDispatch();

  const sensitiveData = useSelector(
    (state) => state.dataTagReducer.sensitiveCardData,
  );

  const dataSourceId = useSelector(
    (state) => state.dataTagReducer.selectedDataSource?.id,
  );

  const data = sensitiveData?.sensitiveData || [];

  const sensitivity_count_critical = Number(
    data.find((d) => d["DataTagSensitivity.category"] === "CRITICAL")?.[
      "DataTagSensitivity.count"
    ] || 0,
  );

  const sensitivity_count_high = Number(
    data.find((d) => d["DataTagSensitivity.category"] === "HIGH")?.[
      "DataTagSensitivity.count"
    ] || 0,
  );

  const sensitivity_count_low = Number(
    data.find((d) => d["DataTagSensitivity.category"] === "LOW")?.[
      "DataTagSensitivity.count"
    ] || 0,
  );

  const sensitivity_count_medium = Number(
    data.find((d) => d["DataTagSensitivity.category"] === "MEDIUM")?.[
      "DataTagSensitivity.count"
    ] || 0,
  );

  const sensitivity_count_no_risk = Number(
    data.find((d) => d["DataTagSensitivity.category"] === "NO_RISK")?.[
      "DataTagSensitivity.count"
    ] || 0,
  );

  const sensitivity_count_not_processed = Number(
    data.find((d) => d["DataTagSensitivity.category"] === "NOT_PROCESSED")?.[
      "DataTagSensitivity.count"
    ] || 0,
  );

  const total_sensitivity_count =
    sensitivity_count_critical +
    sensitivity_count_high +
    sensitivity_count_low +
    sensitivity_count_medium +
    sensitivity_count_no_risk +
    sensitivity_count_not_processed +
    sensitivity_count_critical;

  const sensitiveFormatData = {
    sensitivity_count_critical,
    sensitivity_count_high,
    sensitivity_count_low,
    sensitivity_count_medium,
    sensitivity_count_no_risk,
    sensitivity_count_not_processed,
    sensitivity_count_critical,
    total_sensitivity_count,
  };

  useEffect(() => {
    if (dataSourceId) {
      dispatch({
        type: FETCH_SENSITIVE_SUMMARY_CARD_DATA,
        payload: dataSourceId,
      });
    }
  }, [dataSourceId, dispatch]);

  return data.length > 0 ? (
    <div>
      <SensitivityBadge
        parentprops={sensitiveFormatData}
        loc="DataTag"
        title="Sensitivity:"
      />
    </div>
  ) : (
    <div>No Data Available</div>
  );
}

export default DataEstateSensitiveCard;
